import { render, staticRenderFns } from "./TreatmentProgram.vue?vue&type=template&id=042714e6&scoped=true"
import script from "./TreatmentProgram.vue?vue&type=script&lang=js"
export * from "./TreatmentProgram.vue?vue&type=script&lang=js"
import style0 from "./TreatmentProgram.vue?vue&type=style&index=0&id=042714e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "042714e6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSkeletonLoader})
